import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Amanpreet Singh',
      role: '5.0 Rating • Panipat, Haryana, India',
      content:
        'Jatin Interiors ne hamare living room aur false ceiling ko bilkul premium finish diya. Team time par deliver karti hai aur detailing excellent hai.',
      rating: 5
    },
    {
      id: 2,
      name: 'Neha Sharma',
      role: '4.9 Rating • Kaithal, Haryana, India',
      content:
        'Modular kitchen ka layout, storage planning aur lighting—sab kuch perfect. Materials genuine aur after-support bhi acha raha.',
      rating: 5
    },
    {
      id: 3,
      name: 'Gurleen Kaur',
      role: '5.0 Rating • Karnal, Haryana, India',
      content:
        'Bedroom wardrobes aur TV panel ka design classy laga. Measurements accurate the aur installation clean—overall experience top-notch.',
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span 
        key={index} 
        className="material-symbols-outlined" 
        data-weight="fill"
      >
        {index < rating ? 'star' : 'star_border'}
      </span>
    ));
  };

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-stone-100">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-8 md:px-16">
        <h2 className="text-3xl sm:text-4xl font-bold mb-8 sm:mb-12 md:mb-16 text-center">Voices of Experience</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-12">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-surface p-6 sm:p-8 md:p-12 rounded-xl shadow-sm hover:shadow-xl transition-shadow duration-500"
            >
              {/* Stars */}
              <div className="flex gap-1 text-primary mb-4 sm:mb-6">
                {renderStars(testimonial.rating)}
              </div>
              
              {/* Content */}
              <p className="text-stone-700 leading-relaxed mb-6 sm:mb-8 italic text-sm sm:text-base">
                "{testimonial.content}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-stone-200"></div>
                <div>
                  <h5 className="font-bold text-sm sm:text-base">{testimonial.name}</h5>
                  <p className="text-xs uppercase text-stone-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
